import {
  activeTabColor,
  editable,
  gapUnderTab,
  leaveGap,
  moduleTypeSelect,
  moduleWidthSelect,
  regularTabColor,
  tabStyle,
  tabs,
} from '@/src/tools/contentModulesFieldName';
import {
  EPreviewSize,
  SalesChannelModeWithSister,
} from '@/src/types/common/SalesChannel';
import {
  EModuleWidth,
  EOverflowOption,
  EnumModuleType,
} from '@/src/types/common/module';
import i18n from '../i18n';
import { ResponsiveContainer, ResponsiveField } from '../util';
import {
  ANIMATION,
  MOUDLE_STYLE,
  TAB,
  TABSTYLE,
  TAB_LIST,
  TEXT,
  animationFields,
  moduleStyleFields,
  productTextFields,
} from './constant';
import { tabTypeOptionsGenerator } from './tools';

export default (
  values: any,
  responsiveType: EPreviewSize,
  salesChannelMode: SalesChannelModeWithSister,
) => {
  const tabSetting = getTabTemplate(values, responsiveType, salesChannelMode);
  const moduleStyleSetting = getModuleStyleTemplate(
    values,
    responsiveType,
    EnumModuleType.ResponsiveProductTab,
  );
  const animation = getAnimationTemplate(values, responsiveType);
  const tabStyle = getTabStyleTemplate(values, responsiveType);
  const tabBarSetting = getTabBarListTemplate(values, responsiveType);
  return [
    {
      title: i18n['general.content.tab'],
      id: TAB,
      field: tabSetting,
      fields: [[moduleWidthSelect], [leaveGap]],
    },
    {
      title: i18n['general.content.moduleStyle'],
      id: MOUDLE_STYLE,
      type: ResponsiveContainer.ModuleStyle,
      field: moduleStyleSetting,
      fields: moduleStyleFields,
    },
    {
      title: i18n['general.content.animation'],
      id: ANIMATION,
      field: animation,
      fields: animationFields,
    },
    {
      title: i18n['general.content.text'],
      id: TEXT,
      field: [
        {
          field: ResponsiveField.ProductText,
          disabled:
            responsiveType !== EPreviewSize.WIDE ||
            values[`${TEXT}_${editable}`],
        },
      ],
      fields: productTextFields,
    },
    {
      title: i18n['general.content.tabstyle'],
      id: TABSTYLE,
      field: tabStyle,
      fields: [
        [tabStyle, gapUnderTab],
        [tabStyle, regularTabColor],
        [tabStyle, activeTabColor],
      ],
    },
    {
      title: i18n['general.content.tabSetting'],
      id: TAB_LIST,
      field: tabBarSetting,
      fields: [[tabs]],
    },
  ];
};

export const not_editable = [
  moduleTypeSelect,
  moduleWidthSelect,
  ...moduleStyle_not_editable,
  ...animation_not_editable,
  ...productTextFields,
  [tabStyle, regularTabColor],
  [tabStyle, activeTabColor],
];

export const getTabTemplate = (
  values: any,
  responsiveType: EPreviewSize,
  salesChannelMode: SalesChannelModeWithSister,
) => {
  const v =
    responsiveType === EPreviewSize.WIDE || values[`${TAB}_${editable}`];
  const commonFields: Array<any> = [
    {
      field: ResponsiveField.TabType,
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
      options: tabTypeOptionsGenerator({ salesChannelMode }),
    },
    {
      field: ResponsiveField.ModuleWidth,
      disabled: responsiveType !== EPreviewSize.WIDE || !v,
      options: [
        { label: i18n['general.content.none'], value: EModuleWidth.NONE },
        { label: i18n['general.content.wideWidth'], value: EModuleWidth.WIDE },
        { label: i18n['general.content.fullWidth'], value: EModuleWidth.FULL },
      ],
    },
    {
      field: ResponsiveField.LeaveGap,
      disabled: !v,
    },
  ];
  if (responsiveType !== EPreviewSize.WIDE) {
    commonFields.push({
      field: ResponsiveField.OverflowItems,
      disabled: !v,
      options: [
        // {
        //   label: i18n['general.overflow.carousel'],
        //   value: EOverflowOption.Carousel,
        // },
        {
          label: i18n['general.overflow.anotherline'],
          value: EOverflowOption.AnotherLine,
        },
        { label: i18n['general.overflow.hide'], value: EOverflowOption.Hide },
      ],
    });
  }
  return commonFields;
};

import { get } from 'lodash';
import {
  animation_not_editable,
  getAnimationTemplate,
  getModuleStyleTemplate,
  moduleStyle_not_editable,
} from './imageCarousel';
import { getTabStyleTemplate } from './posterTab';
import { productInRowOptions } from './productGrid';

const getTabBarListTemplate = (values: any, responsiveType: EPreviewSize) => {
  const v =
    responsiveType === EPreviewSize.WIDE || values[`${TAB_LIST}_${editable}`];
  const tabs = get(values, 'tabs', []) || [];
  const list = tabs.map((tab, index) => {
    return {
      field: ResponsiveField.TabBarSetting,
      disabled: !v,
      options: productInRowOptions(responsiveType),
      extra: {
        index,
        tabDraggableId: get(tab, 'draggableId'),
        title: get(tab, 'title'),
      },
    };
  });
  return [{ field: ResponsiveField.AllTabs, disabled: !v }, ...list];
};
